import "./AppLinkButton.scss";

import Button from "react-bootstrap/Button";
import React from "react";
import classNames from "classnames";

type AppLinkButtonSize = "sm" | "md" | "lg";
type AppLinkButtonVariantStyle = "outline" | "ghost";
type AppLinkButtonIntent = "neutral" | "success" | "danger";

interface AppLinkButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  size?: AppLinkButtonSize;
  fullWidth?: boolean;
  variantStyle?: AppLinkButtonVariantStyle;
  intent?: AppLinkButtonIntent; // ✅ novo
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  loading?: boolean;
}

const AppLinkButton: React.FC<AppLinkButtonProps> = ({
  name,
  onClick,
  size = "md",
  fullWidth = true,
  variantStyle = "outline",
  intent = "neutral", // ✅ novo (padrão)
  leftIcon,
  rightIcon,
  disabled,
  className,
  loading = false,
  ...rest
}) => {
  const isDisabled = disabled || loading;

  return (
    <Button
      {...rest}
      onClick={onClick}
      disabled={isDisabled}
      type={rest.type || "button"}
      style={{ textDecoration: "none" }}
      className={classNames(
        "hallapp-btn",
        `hallapp-btn--${size}`,
        { "hallapp-btn--block": fullWidth, "is-loading": loading },

        // base secondary
        "hallapp-btn--secondary",

        // outline/ghost
        variantStyle === "ghost" ? "hallapp-btn--ghost" : "hallapp-btn--outline",

        // ✅ intent (neutral/success/danger)
        intent !== "neutral" ? `hallapp-btn--intent-${intent}` : "",

        className
      )}
      aria-busy={loading || undefined}
    >
      {leftIcon && <span className="hallapp-btn__icon hallapp-btn__icon--left">{leftIcon}</span>}
      <span className="hallapp-btn__label">{name?.toUpperCase()}</span>
      {rightIcon && <span className="hallapp-btn__icon hallapp-btn__icon--right">{rightIcon}</span>}
    </Button>
  );
};

export default AppLinkButton;
